import { DeleteResponse, WorkDetailListResponse, WorkDetailResponse, WorkDetailSimpleListResponse, PreSignedUrlBatchResponse } from '../dto/ResDtoRepository';
import { DeleteWorkDetailReq, UpdateWorkDetailReq, PreSignedUrlWorkBatchReq, UpdateWorkDetailBulkReq, UpdateWorkDetailBulkInfoReq, UpdateReorderListReq } from '../dto/ReqDtoRepository';
import { sendApiRequest, sendDeleteApiRequest, sendGetApiRequest } from './apiConfig';


export const getWorkDetail = async (aui: string, workDetailId: string): Promise<WorkDetailResponse> => {
  return sendGetApiRequest<WorkDetailResponse>(`/api/v1/work-detail?aui=${aui}&workDetailId=${workDetailId}`);
};

/** 소유자: PE Import / Formation 슬롯에서 Detail 목록. public GET이 아님. */
export const getSimpleWorkDetailListForOwner = async (aui: string, workId: string): Promise<WorkDetailSimpleListResponse> => {
  return sendApiRequest<WorkDetailSimpleListResponse>(
    'get',
    `/api/v1/work-detail/list/simple/owner?aui=${aui}&workId=${workId}`,
  );
};

export const getWorkDetailList = async (aui: string, workId: string): Promise<WorkDetailListResponse> => {
  return sendGetApiRequest<WorkDetailListResponse>(`/api/v1/work-detail/list?aui=${aui}&workId=${workId}`);
};

export const createWorkDetailBulk = async (aui: string, data: PreSignedUrlWorkBatchReq): Promise<PreSignedUrlBatchResponse> => {
  return sendApiRequest<PreSignedUrlBatchResponse>('post', `/api/v1/work-detail/bulk?aui=${aui}`, data);
};

/** 생성 직후 이미지 URL 반영. 편집 저장(정보 일괄 수정)은 bulk-info. */
export const updateWorkDetailBulk = async (aui: string, data: UpdateWorkDetailBulkReq): Promise<WorkDetailListResponse> => {
  return sendApiRequest<WorkDetailListResponse>('put', `/api/v1/work-detail/bulk?aui=${aui}`, data);
};

/** 작품 편집에서 변경된 Detail만 일괄 저장. Work PUT과 별개. */
export const updateWorkDetailBulkInfo = async (aui: string, data: UpdateWorkDetailBulkInfoReq): Promise<WorkDetailListResponse> => {
  return sendApiRequest<WorkDetailListResponse>('put', `/api/v1/work-detail/bulk-info?aui=${aui}`, data);
};

export const toggleDetailAllowDownload = async (aui: string, data: UpdateWorkDetailReq): Promise<WorkDetailResponse> => {
  return sendApiRequest<WorkDetailResponse>('put', `/api/v1/work-detail/toggle-download?aui=${aui}`, data);
};

export const deleteWorkDetail = async (aui: string, data: DeleteWorkDetailReq): Promise<DeleteResponse> => {
  return sendDeleteApiRequest<DeleteResponse>(`/api/v1/work-detail?aui=${aui}&workDetailId=${data.workDetailId}`);
};

export const reorderWorkDetail = async (aui: string, data: UpdateReorderListReq): Promise<WorkDetailListResponse> => {
  return sendApiRequest<WorkDetailListResponse>('put', `/api/v1/work-detail/reorder?aui=${aui}`, data);
};


